import { type Interval, differenceInMilliseconds, getTime } from "~/tools/date-time";
import type { Time } from "~/tools/date-time/time";
import { trunc } from "~/tools/trunc";

export interface TimeFromPxParams {
	px: number;
	interval: Interval;
	width: number;
}

export function timeFromPx({ px, interval: { start, end }, width }: TimeFromPxParams): Time {
	if (width <= 0) {
		return getTime(start);
	}

	const ratio = width / differenceInMilliseconds(end, start);
	const timestamp = getTime(start) + px / ratio;

	// should return epoch time, which is an integer, not a decimal
	return trunc(timestamp);
}
